import * as React from 'react';

import type { IconProps } from './types';

export const H1 = React.forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', ...props }, forwardedRef) => (
  <svg
    width="16"
    height="13"
    viewBox="0 0 16 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={forwardedRef}
  >
    <g clipPath="url(#clip0_300_64)">
      <path
        d="M8.83333 0.472656C8.39474 0.472656 7.95614 0.508424 7.53509 0.579959V5.01513H3.11404V0.579959C2.64035 0.508424 2.20175 0.472656 1.76316 0.472656C1.32456 0.472656 0.903509 0.508424 0.5 0.579959V12.0434C0.95614 12.115 1.37719 12.1507 1.81579 12.1507C2.25439 12.1507 2.69298 12.115 3.11404 12.0434V7.4652H7.53509V12.0434C8.00877 12.115 8.44737 12.1507 8.88597 12.1507C9.32456 12.1507 9.74561 12.115 10.1667 12.0434V0.579959C9.69298 0.508424 9.27193 0.472656 8.83333 0.472656Z"
        fill={color}
      />
      <path
        d="M15.192 4.15063C14.94 4.15063 14.688 4.17463 14.472 4.22263L12 5.32663C12.012 5.95063 12.324 6.52663 12.636 6.85063L14.124 6.23863V12.0586C14.424 12.1066 14.712 12.1306 15.012 12.1306C15.3 12.1306 15.6 12.1066 15.9 12.0586V4.22263C15.696 4.17463 15.432 4.15063 15.192 4.15063Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_300_64">
        <rect width="16" height="12" fill="white" transform="translate(0 0.150635)" />
      </clipPath>
    </defs>
  </svg>
));

export default H1;
